import React, { useEffect, useState } from "react";
import {
  MdOutlineCheckBoxOutlineBlank,
  MdCheck,
  MdCheckBox,
} from "react-icons/md";

const Checkbox = ({ label, userQuery, setUserQuery }) => {
  const [checkbox, setCheckbox] = useState(false);

  // A function that Handle Click events on the checkbox

  useEffect(() => {
    if (label === "Waive") {
      setCheckbox(userQuery.waive_escrows === true ? true : false);
    }
    if (label === "Self Employed") {
      setCheckbox(userQuery.employment === true ? true : false);
    }
    if (label === "First Time Home Buyer") {
      setCheckbox(userQuery.FTHB === true ? true : false);
    }
    if (label === "Includes LLC") {
      setCheckbox(userQuery.LLC === true ? true : false);
    }
    console.log("waive_escrows", userQuery.waive_escrows);
  }, []);

  const handleclick = (label) => {
    setCheckbox((prev) => !prev); // Toggle checkbox state
    if (label === "Waive") {
      setUserQuery((prev) => ({ ...prev, waive_escrows: !checkbox }));
    }
    if (label === "Self Employed") {
      setUserQuery((prev) => ({ ...prev, employment: !checkbox }));
    }
    if (label === "Includes LLC") {
      setUserQuery((prev) => ({ ...prev, LLC: !checkbox }));
    }
    if (label === "First Time Home Buyer") {
      setUserQuery((prev) => ({ ...prev, FTHB: !checkbox }));
    }
  };

  return (
    <div className="flex mt-4 items-center border border-[#e0e0e0] rounded pl-3">
      <div
        onClick={() => {
          handleclick(label);
        }}
        className={`flex justify-center items-center h-[42px]    cursor-pointer  hover:bg-white  duration-100 ease-in-out
        ${checkbox === true ? "bg-white rounded-l-md" : "rounded-l-md "}`}
      >
        {checkbox ? (
          <MdCheckBox size={25} color="#0065cc" />
        ) : (
          <MdOutlineCheckBoxOutlineBlank size={25} />
        )}
        <input type="checkbox" value={label} className="hidden" />
      </div>

      <label
        className={`w-11/12 p-2.5 text-base   font-normal     order rounded-r-md cursor-pointer   ${
          checkbox ? "text-[#000]" : "text-[#B3B3B3]"
        }`}
        onClick={() => {
          handleclick(label);
        }}
      >
        {label}
      </label>
    </div>
  );
};

export default Checkbox;
